import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FlightBookResponse } from 'ts/flight/interfaces/FlightBookResponse';
import { Outbound } from 'ts/flight/interfaces/FlightDetailsResponse';
import { getBook } from 'services/flight';
import { getBounds } from 'utils/flight/flight';
import { dateFormat } from 'utils/shared/utils';
import { useTranslation } from 'react-i18next';
import { b2b } from 'constants/generic';

const useFlightBook = () => {
  const [urlParams] = useSearchParams();
  const [response, setResponse] = useState<FlightBookResponse>();
  const [bounds, setBounds] = useState<Outbound[]>([]);
  const [boundsPair, setBoundsPair] = useState<Outbound[]>([]);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (b2b) {
      if (
        pathname.toLowerCase() !== `/flight/book` &&
        pathname.toLowerCase() !== `/multiflight/book`
      ) {
        return;
      }
    }
    (async () => {
      if (b2b) {
        setResponse(undefined);
        setBounds([]);
        setBoundsPair([]);
      }

      const params = Object.fromEntries(urlParams);
      const newResponse = await getBook(params as any);

      if (newResponse?.saleRedirectToSearch && newResponse.saleRedirectSearchParams?.outbound) {
        const searchParams = new URLSearchParams({
          departureCode: newResponse.saleRedirectSearchParams.departureCode,
          arrivalCode: newResponse.saleRedirectSearchParams.arrivalCode,
          departureDate: dateFormat(
            newResponse.saleRedirectSearchParams.departureDate,
            'yyyy-MM-dd'
          ),
          arrivalDate: dateFormat(newResponse.saleRedirectSearchParams.arrivalDate, 'yyyy-MM-dd'),
          departureDesc:
            newResponse.saleRedirectSearchParams.departureDesc ||
            newResponse.saleRedirectSearchParams.departureCode,
          arrivalDesc:
            newResponse.saleRedirectSearchParams.arrivaleDesc ||
            newResponse.saleRedirectSearchParams.arrivalCode,
          numberOfAdults: newResponse.saleRedirectSearchParams.numberOfAdults + '',
          numberOfChildren: newResponse.saleRedirectSearchParams.numberOfChildren + '',
          numberOfYouths: newResponse.saleRedirectSearchParams.numberOfYouths + '',
          numberOfSeniors: newResponse.saleRedirectSearchParams.numberOfSeniors + '',
          numberOfInfants: newResponse.saleRedirectSearchParams.numberOfInfants + '',
          cabineType: newResponse.saleRedirectSearchParams.cabineType,
          searchType: newResponse.saleRedirectSearchParams.searchType,
          directFlight: newResponse.saleRedirectSearchParams.directFlight.toString(),
        });

        navigate({ pathname: '/flights/results', search: searchParams.toString() });
      } else if (newResponse?.saleRedirectToSearch && !newResponse.saleRedirectSearchParams) {
        setResponse({ ...newResponse, hasErrors: true, errorMessage: 'Flight not found' });
      } else {
        setResponse(newResponse);
      }

      if (newResponse?.bookingModel?.flight) {
        const newBounds = getBounds(newResponse.bookingModel.flight);
        setBounds(newBounds);
      }

      if (newResponse?.bookingModel?.flightPair) {
        const newBoundsPair = getBounds(newResponse.bookingModel.flightPair);
        setBoundsPair(newBoundsPair);
      }
    })();
  }, [pathname, i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    response,
    bounds,
    boundsPair,
    setResponse,
  };
};

export default useFlightBook;
